import styles from './styles.scss';
import React, { useEffect, useState } from 'react';
import {Icon} from 'react-weui';


export default (props) => {

  const { onChange, onClick,onConfirmKey,showButton,onSearch } = props;

  const [text, setText] = useState('');

  useEffect(() => {
    setText(props.value);
  },[props.value]);


  return (
    <div className={styles.box}>
      {props.disable ?
        <div className={styles.search_bg} onClick={()=>{
          onClick && onClick();
        }}>
          <Icon value='search'/>
          <label >{text? text : props.placeholder}</label>
        </div>
        :
        <div className={styles.search_bg}>
          <Icon value='search'/>
          <input className={styles.search_input}
                 defaultValue={props.defaultValue}
                 value={text}
                 type='search'
                 placeholder={props.placeholder}
                 onChange={ e => {
                   setText(e.target.value);
                   onChange && onChange(e.target.value);
                 }}
                 onKeyDown={(e)=>{
                   if (e.keyCode == 13) {
                     onConfirmKey && onConfirmKey();
                   }
                 }}

          />
          {text ? <a
            className='weui-icon-clear'
            onClick={()=>{
              setText('')
              onChange && onChange('');
            }}
          /> : null}

        </div>
      }

      {showButton &&
      <div className={styles.searchBtn} onClick={()=>{
        onSearch && onSearch(text);
      }}>搜索</div>
      }

    </div>
  )
}
